import { colors } from '@omilia/theme';
import { PDFDownloadLink } from '@react-pdf/renderer';
import styled from 'styled-components';
import { getThemeProp } from 'styles/theme';

export const SContainer = styled.div``;

export const SMessage = styled.div`
  background-color: ${colors.COLOR_ORANGE_100};
  border-radius: 4px;
  border: 1px solid ${colors.COLOR_ORANGE_300};
  color: ${colors.COLOR_ORANGE_900};
  font-size: 14px;
  font-weight: 400;
  line-height: 150%;
  padding: 16px;
  font-family: ${getThemeProp('fontFamily')};
`;

export const SButtonGroup = styled.div`
  margin-top: 8px;
  display: flex;
  justify-content: space-around;

  a {
    margin-right: 12px;
  }
`;

const buttonStyles = `
  background-color: ${colors.COLOR_WHITE};
  border-radius: 8px;
  border: 1px solid ${colors.COLOR_DEEP_PURPLE_800};
  color: ${colors.COLOR_DEEP_PURPLE_900};
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  line-height: 16px;
  margin-top: 12px;
  padding: 13px 18px;
  font-family: ${getThemeProp('fontFamily')};
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.1);
  text-align: center;

  &:hover:not(:disabled) {
    background-color: ${colors.COLOR_DEEP_PURPLE_100};
    color: ${colors.COLOR_DEEP_PURPLE_1000};
  }

  &:active:not(:disabled) {
    outline: 3px solid ${colors.COLOR_DEEP_PURPLE_300};
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.4;
  }
`;

export const SButton = styled.button`
  ${buttonStyles}
`;

export const SDownloadPDF = styled(PDFDownloadLink)`
  ${buttonStyles}
  text-decoration: none;
  display: inline-block;
`;
